// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import {
  GET_ALL_POSITIONS_FAIL,
  GET_ALL_POSITIONS_REQUEST,
  GET_ALL_POSITIONS_SUCCESS,
} from "../constants/createEvent";
import {
  CREATE_POSITION_FAILURE,
  CREATE_POSITION_REQUEST,
  CREATE_POSITION_SUCCESS,
  DELETE_POSITION_FAILURE,
  DELETE_POSITION_REQUEST,
  DELETE_POSITION_SUCCESS,
  EDIT_POSITION_FAILURE,
  EDIT_POSITION_REQUEST,
  EDIT_POSITION_STATUS_FAILURE,
  EDIT_POSITION_STATUS_REQUEST,
  EDIT_POSITION_STATUS_SUCCESS,
  EDIT_POSITION_SUCCESS,
  FETCH_POSITION_CATEGORY_FAILURE,
  FETCH_POSITION_CATEGORY_REQUEST,
  FETCH_POSITION_CATEGORY_SUCCESS,
  FETCH_POSITION_FAILURE,
  FETCH_POSITION_REQUEST,
  FETCH_POSITION_SUCCESS,
  SEARCH_POSITION_BY_TEXT_FAILURE,
  SEARCH_POSITION_BY_TEXT_REQUEST,
  SEARCH_POSITION_BY_TEXT_SUCCESS,
} from "../constants/positions";
import { alertDialogAciton } from "./auth";

export const getAllPositions = ({
  payload = {},
  beforeCallback,
  afterCallback,
  successCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_ALL_POSITIONS_REQUEST });

    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "GET",
      url: `fetchPositions`,
      params: {
        sortOrder: "asc",
        sortField: "positionName",
        ...payload?.params,
      },
      isToken: false,
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      dispatch({
        type: GET_ALL_POSITIONS_SUCCESS,
        payload: {
          positions: response.data?.data?.positions,
          totalPages: response.data?.data?.totalPages,
        },
      });

      if (successCallback) {
        successCallback({
          response,
        });
      }
    } else if (error) {
      dispatch({ type: GET_ALL_POSITIONS_FAIL });
    }
  };
};

export const fetchPositionsAction = ({ payload, params, successCallback }) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_POSITION_REQUEST,
      payload: { name: params?.name || "", rPerPage: params?.limit },
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `fetchPositions`,
      params,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: FETCH_POSITION_SUCCESS, payload: response?.data });
      if (successCallback) successCallback();
    } else if (error) {
      dispatch({ type: FETCH_POSITION_FAILURE });
    }
  };
};

// Delete positions
export const deletePositionAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `positionDelete/${payload.id}`,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: DELETE_POSITION_SUCCESS, payload: payload?.index });
      if (successCallback) successCallback();
    } else if (error || response?.status !== 200) {
      dispatch({ type: DELETE_POSITION_FAILURE });
    }
  };
};

// Edit position status
export const editPositionStatusAction = (payload) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_POSITION_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `positionUpdate/${payload.id}`,
      data: payload,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: EDIT_POSITION_STATUS_SUCCESS, payload: payload.id });
    } else if (error || response?.status !== 200) {
      dispatch({ type: EDIT_POSITION_STATUS_FAILURE });
    }
  };
};

// create position
export const createPositionAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "add_Position",
      data: payload,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: CREATE_POSITION_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback();
    } else if (error || response?.status !== 200) {
      dispatch({ type: CREATE_POSITION_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message || "Failed to create position",
        }),
      );
    }
  };
};

// edit position
export const editPositionAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `positionUpdate/${payload?.id}`,
      data: payload?.updatedData,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: EDIT_POSITION_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.(response?.data);
    } else if (error || response?.status !== 200) {
      dispatch({ type: EDIT_POSITION_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message || "Failed to update position",
        }),
      );
    }
  };
};

// search position by text
export const searchPositionByTextAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: SEARCH_POSITION_BY_TEXT_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `fetchPositions?name=${payload?.searchStr || ""}&page=${payload?.page}`,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: SEARCH_POSITION_BY_TEXT_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback();
    } else if (error || response?.status !== 200) {
      dispatch({ type: SEARCH_POSITION_BY_TEXT_FAILURE });
    }
  };
};

// get position logs
export const getPositionLogs = ({
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback,
  params,
}) => {
  return async (dispatch) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "GET",
      url: `retrievePositionLogs`,
      params,
      data: null,
      isToken: true,
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          response,
        });
      }
    } else {
      failureCallback({
        error,
      });
    }
  };
};

/**
 * fetch positions category action
 * api/v2/fetchPositionCategories?page=1&limit=10&search=Management
 */
export const fetchPositionsCategoryAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_POSITION_CATEGORY_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "fetchPositionCategories",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: FETCH_POSITION_CATEGORY_SUCCESS,
        payload: [
          ...new Set(
            response?.data?.data?.positions
              ?.map((p) => p?.category)
              ?.filter((p) => !!p),
          ),
        ],
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_POSITION_CATEGORY_FAILURE });
      failureCallback?.();
    }
  };
};